<script>
  import { onMount } from 'svelte';
  import { logger } from '../utils/logger.js';
  import { t } from '../services/i18n.js';

  let { children } = $props();

  let hasError = $state(false);
  let errorMessage = $state('');
  let errorStack = $state('');

  function handleError(event) {
    const error = event.error || event.reason || event;
    
    hasError = true;
    errorMessage = error.message || 'Ocorreu um erro inesperado';
    errorStack = error.stack || '';

    logger.error('ErrorBoundary caught error:', error);
  }

  function resetError() {
    hasError = false;
    errorMessage = '';
    errorStack = '';
    window.location.reload();
  }

  onMount(() => {
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  });
</script>

{#if hasError}
  <div class="error-boundary" role="alert">
    <div class="error-content">
      <div class="error-icon" aria-hidden="true">😿</div>
      <h1 class="error-title">{$t('error.title')}</h1>
      <p class="error-message">{errorMessage}</p>
      
      {#if errorStack && import.meta.env.DEV}
        <details class="error-details">
          <summary>Detalhes técnicos</summary>
          <pre>{errorStack}</pre>
        </details>
      {/if}

      <div class="error-actions">
        <button class="btn-primary" onclick={resetError}>
          {$t('error.reload')}
        </button>
        <a href="/" class="btn-secondary">
          {$t('error.goHome')}
        </a>
      </div>
    </div>
  </div>
{:else}
  {@render children()}
{/if}

<style>
  .error-boundary {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-lg);
    background-color: var(--color-background);
  }

  .error-content {
    max-width: 500px;
    text-align: center;
  }

  .error-icon {
    font-size: 4rem;
    margin-bottom: var(--spacing-md);
  }

  .error-title {
    color: var(--color-error);
    margin-bottom: var(--spacing-sm);
    font-size: 1.5rem;
  }

  .error-message {
    color: var(--color-text-secondary);
    margin-bottom: var(--spacing-lg);
  }

  .error-details {
    text-align: left;
    margin-bottom: var(--spacing-lg);
    background-color: var(--color-surface);
    border-radius: var(--border-radius);
    padding: var(--spacing-sm);
  }

  .error-details summary {
    cursor: pointer;
    color: var(--color-text-secondary);
    font-size: 0.875rem;
  }

  .error-details pre {
    margin-top: var(--spacing-sm);
    font-size: 0.75rem;
    overflow-x: auto;
    white-space: pre-wrap;
    word-break: break-word;
    color: var(--color-error);
  }

  .error-actions {
    display: flex;
    gap: var(--spacing-md);
    justify-content: center;
    flex-wrap: wrap;
  }

  .btn-primary {
    background-color: var(--color-primary);
    color: white;
    padding: var(--spacing-sm) var(--spacing-lg);
    border: none;
    border-radius: var(--border-radius);
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: background-color var(--transition-fast);
  }

  .btn-primary:hover {
    background-color: var(--color-primary-dark);
  }

  .btn-secondary {
    background-color: transparent;
    color: var(--color-primary);
    padding: var(--spacing-sm) var(--spacing-lg);
    border: 2px solid var(--color-primary);
    border-radius: var(--border-radius);
    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;
    transition: all var(--transition-fast);
  }

  .btn-secondary:hover {
    background-color: var(--color-primary);
    color: white;
  }
</style>
